{
  "Seguimiento del pedido": "Bestelling volgen",
  "Enviado": "Verzonden",
  "Empaquetado": "Verpakt",
  "Recibido": "Ontvangen",
  "Items del pedido": "Bestelartikelen",
  "En proceso": "In behandeling",
  "Devolución solicitada": "Retour aangevraagd",
  "Devolución en proceso": "Retour in behandeling",
  "Devuelto": "Geretourneerd",
  "Envío": "Zending",
  "Devolución": "Retour",
  "Ver en tienda": "Ga naar de winkel",
  "Solicitudes de devolución": "Retourverzoeken",
  "Envíos": "Zendingen",
  "Confirmado": "Bevestigd",
  "En curso": "Onderweg",
  "Seguimiento de envío": "Verzending volgen",
  "Destino": "Bestemming",
  "Dirección destino": "Bestemmingsadres",
  "Última actualización": "Laatste update",
  "Devolución pendiente": "Retourzending in behandeling",
  "Recogida solicitada": "Collectie aangevraagd",
  "Devolución enviada": "Retour gezonden",
  "Entrega estimada": "Geschatte levering",
  "Valora tu experiencia con nosotros": "Beoordeel uw ervaring met ons",
  "¡Gracias!": "Bedankt!",
  "Mensaje de alerta": "Waarschuwingsbericht",
  "Punto de recogida": "Afhaalpunt",
  "Mostrar historial completo": "Volledige geschiedenis tonen",
  "Ocultar historial": "Geschiedenis verbergen",
  "¿Necesitas hacer una devolución o cambio?": "Wil je iets retourneren of ruilen?",
  "¿Quieres devolver algo más?": "Wil je nog iets retourneren?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Retourneer of ruil je artikel in een paar eenvoudige stappen.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Start het proces in een paar stappen. We begeleiden je door het hele proces.",
  "Abrir el portal de devoluciones": "Naar het retourportaal",
  "Enviando": "Verzenden",
  "¡Página no encontrada!": "Pagina niet gevonden!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Sorry, de pagina die je zocht kon niet worden gevonden",
  "Puedes volver al ": "Je kunt terug naar het ",
  "principio": "begin",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "of schrijf ons via support@reveni.io als je niet kunt vinden wat je zocht"
}
